import { useEffect, useRef } from 'react'
import { useSession } from '../../state/session'

/**
 * Send a visitor who arrives already signed in somewhere useful: the login
 * and forgot-password pages have nothing for them.
 *
 * The status is deliberately read once, at mount, rather than watched: a
 * successful sign-in on the login page also flips it to authenticated, and
 * reacting to that would fire a second navigation racing the one the form
 * makes — the browser aborts one of them and the redirect intermittently
 * fails. `replace` rather than `assign` so Back doesn't bounce them here again.
 */
export function useRedirectIfSignedIn(destination: string): void {
  const status = useSession((state) => state.status)
  const arrivedSignedIn = useRef(status === 'authenticated')

  useEffect(() => {
    if (arrivedSignedIn.current) window.location.replace(destination)
  }, [destination])
}
